import { environment } from '@env/environment';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject, combineLatest, first, map, Subscription, tap } from 'rxjs';
import { UserAccessService } from '@services/user-access.service';

@Component({
  selector: 'app-carto',
  templateUrl: './carto.component.html',
  styleUrls: ['./carto.component.scss'],
})
export class CartoComponent implements OnInit, OnDestroy {
  iframe: HTMLIFrameElement;
  cartoIframeUrl: SafeResourceUrl;
  userAccessToken: string | undefined;
  isIframeHasMessage: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private url = environment.adminUrl;
  private subscription: Subscription;

  private readonly iframeOrigin = new URL(environment.cartoIframeUrl).origin;

  constructor(
    private sanitizer: DomSanitizer,
    private userAccessService: UserAccessService
  ) {
    this.cartoIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.cartoIframeUrl);
  }


  ngOnInit(): void {
    this.iframe = document.getElementById('myIframe') as HTMLIFrameElement;
    this.subscription = combineLatest([
      this.userAccessService.getToken$().pipe(map((data) => data.token), first(Boolean)),
      this.isIframeHasMessage.asObservable().pipe(first(Boolean))
    ]).pipe(
      tap(([token]) => {
        this.iframe?.contentWindow?.postMessage({ token }, this.iframeOrigin);
      })
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent): void {
    if (!this.iframe?.contentWindow) {
      return;
    }
    if (event.origin !== this.iframeOrigin) {
      return;
    }
    if (event.source !== this.iframe.contentWindow) {
      return;
    }
    this.isIframeHasMessage.next(true);
  }
}
